import { Amplify } from 'aws-amplify';

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN?.replace('https://', '') || '',
            scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [import.meta.env.VITE_CALLBACK_URL || 'http://localhost:5173/callback'],
            redirectSignOut: [import.meta.env.VITE_LOGOUT_URL || 'http://localhost:5173/'],
            responseType: 'code',
            providers: ['Google']
          }
        }
      }
    }
  });
}

// Auth configuration for the Authenticator component
export const authConfig = {
  socialProviders: ['google' as const],
  initialState: 'signIn' as const,
  loginMechanisms: ['email' as const],
  enableSignUp: false, // Only allow social sign-in
  messages: {
    signUpDisabled: 'Sign up is only available through Google. Click the Google button below to continue.'
  }
};
